import React from 'react';
import { useSteps } from '../../contexts/stepContext';
import TableItem from '../TableItem';
import { Table, TableContainer, TableHeadColumn } from './styles';

const TableArea: React.FC = () => {
  const { diffPlates, listPlatesPerPage } = useSteps();
  return (
    <TableContainer>
      <Table>
        <thead>
          <tr>
            <TableHeadColumn width="25%">Placa</TableHeadColumn>
            {!listPlatesPerPage ? (
              <TableHeadColumn width="50%">Local</TableHeadColumn>
            ) : (
              <TableHeadColumn width="50%">Modelo do Carro</TableHeadColumn>
            )}
            <TableHeadColumn width="25%">Detalhes</TableHeadColumn>
          </tr>
        </thead>
        <div>
          {listPlatesPerPage ? (
            <tbody>
              {listPlatesPerPage.map(plate => (
                <TableItem key={plate.car_plate} plate={plate} />
              ))}
            </tbody>
          ) : (
            <tbody>
              {diffPlates.map(plate => (
                <TableItem key={plate.car_plate} plate={plate} />
              ))}
            </tbody>
          )}
        </div>
      </Table>
    </TableContainer>
  );
};

export default TableArea;
